import React, {useEffect, useState} from 'react';

import {toast} from 'react-toastify';
import {
    requestFetchDicts,
    requestSaveDicts
} from '@app/services/ExtractService';
import {Messages} from "@app/constants/Messages";

const DictItems = (props) => {
    const [items, setItems] = useState('');

    const {dictType} = props
    const {title} = props

    useEffect(() => {
        if (dictType) {
            requestFetchDicts(dictType).then(res => {
                setItems(res.content);
            });
        }
    }, [dictType]);

    const onClickSave = async (values) => {
        const res = await requestSaveDicts({key: dictType, content: values});
        toast.success(Messages.saveInfoSuccess);
        return res;
    };

    return (
        <div className="form-group">
            <label htmlFor="inputDescription">{title}</label>
            <button
                id="sensitiveWords"
                type="submit"
                className="btn btn-primary btn-sm float-right"
                onClick={() => onClickSave(
                    items
                )}
            >
                Save
            </button>
            <textarea
                className="form-control"
                rows="10"
                value={items}
                onChange={(event) =>
                    setItems(event.target.value.toLowerCase())
                }
            />
        </div>
    );
};

export default DictItems;
